import $ from '../$';
import contains from '../functions/contains';
$.contains = contains;
